import { filterUndefined } from '../../../../../utils/FilterUndefinedObject';
import { useTeacherCurriculum } from '../../../common/context/TeacherCurriculumContextProvider';
import PdfContainer from './PdfContainer';

const defaultProps = {
  loadingMessage: null,
  noPdfFoundMessage: null,
};

const GuidePdf = (p) => {
  const {
    loadingMessage,
    noPdfFoundMessage,
  } = { ...defaultProps, ...filterUndefined(p) };
  const { teacherCurriculumDomain } = useTeacherCurriculum();
  const { guidePdfLink } = teacherCurriculumDomain.domainData;

  return (
    <PdfContainer
      pdfKey={guidePdfLink}
      loadingMessage={loadingMessage}
      noPdfFoundMessage={noPdfFoundMessage}
    />
  );
};

export default GuidePdf;
